import React, { useState, useEffect } from 'react';
import { SERVER_URL } from "../../constants/constants.js";
import { dealjacketActions } from "../../actions";
import { connect } from "react-redux";
import Dynamsoft from 'dwt';


function ScanModal(props) {
    const {
        org_id,
        dealjacket_id,
        authentication,
        toggleScanModal,
        jacketInfo
    } = props;

    const [containerId, setContainerId] = useState("dwtcontrolContainer");
    const [DWObject, setDWObject] = useState({});
    const [imagesInDocument, setImagesInDocument] = useState(0);
    const [uploadSuccess, setUploadSuccess] = useState(false);
    const [showSpinner, setShowSpinner] = useState(false);


    const jwt = authentication.jwt;
    const upload_url = SERVER_URL + "/org/" + org_id + "/dealjacket/" + dealjacket_id
        + "/addon/review?token=" + jwt;

    const spinnerImage = require("../../images/spinner-purple.svg").default;    

    useEffect(() => {

        if (!Dynamsoft.DWT.organizationID) {
            console.log("setting DWT organizationID.")
            Dynamsoft.DWT.organizationID = "100657642";
          }
        Dynamsoft.DWT.ResourcesPath = "/dwt-resources";
        Dynamsoft.DWT.Containers = [{
            ContainerID: containerId,
            Width: '400px',
            Height: '400px'
        }]

        Dynamsoft.DWT.CustomizableDisplayInfo.loaderBarSource = spinnerImage;

        Dynamsoft.DWT.CreateDWTObjectEx({
            WebTwainId: 'dwtcontrol'
        },
            function (obj) {
                console.log(obj);
                setDWObject(obj);
            },
            function (err) {
                console.log(err);
            }
        );

        return () => {
            Dynamsoft.DWT.DeleteDWTObject('dwtControl');
          }
    }, [containerId]);

    const clearImagesInDocument = () => {
        DWObject.RemoveAllImages();
        setImagesInDocument(0);
        setUploadSuccess(false);
    };
    
    const makeRequest = (url, formData) => {
        // Set up the request
        setShowSpinner(true);
        console.log("showspinner true");
        let xhr;
        if (window.XMLHttpRequest) {
            xhr = new XMLHttpRequest();
        } else {
            if (window.ActiveXObject) {
                try {
                    xhr = new ActiveXObject("MSXML2.XMLHTTP.3.0");
                } catch (ex) {
                    alert(ex);
                }
            }
        }
        if (xhr) {
                // Send the Data via POST
                xhr.open("POST", url, false);
                if (formData != null) {
                    xhr.send(formData);
                    setShowSpinner(false);
                    setUploadSuccess(true);
                    console.log("showspinner false");
                    alertSuccess("Your document has been uploaded. It will appear in search within a few minutes.")
                } else {
                    xhr.send(null);
                }
            
        } else {
            alert("Sorry, but I couldn't create an XMLHttpRequest! ");
        }
        
        
    }    

    const uploadDoc = () => {
        const indices = DWObject.SelectAllImages();
        console.log(indices);
       
        DWObject.ConvertToBlob(
            indices,
            4,
            function(result, _indices, type) {
                var url = upload_url
                var fileName = "upload.pdf";
                var formData = new FormData();
                formData.append('file', result, fileName);
                makeRequest(url, formData);
            },
            function(errorCode, errorString) {
                console.log(errorCode + ":" + errorString);
            }
        );

    }

    const acquireImage = () => {
        setUploadSuccess(false);
        if (DWObject) {
            DWObject.RegisterEvent("OnPostTransfer", function () {
            setImagesInDocument(DWObject.HowManyImagesInBuffer);
            });
    
            DWObject.Viewer.unbind();
            DWObject.Viewer.bind(document.getElementById(containerId));
            DWObject.Viewer.height = 400;
            DWObject.Viewer.width = 400;
            var thumbnailViewer = DWObject.Viewer.createThumbnailViewer();
            thumbnailViewer.show();
            DWObject.Viewer.show();
    
            // console.log("DWObject:");
            // console.log(DWObject);
            DWObject.SelectSource(function () {
    
            DWObject.OpenSource();
            DWObject.AcquireImage();
            //setImagesInDocument(DWObject.HowManyImagesInBuffer);
            }, function () {
            console.log('SelectSource failed!');
            });
        }
        }        

    return (
        <div className="classifyDeal">
            <div className="classifyForm">
                <form className="ingestorForm">
                    <table className="classifyFormTable">
                        <tbody>
                            <tr><td colSpan="2"><h3>Scan and Upload Addon</h3></td></tr>
                            <tr><td colSpan="2"><hr /></td></tr>
                            <tr><td colSpan="2">&nbsp;</td></tr>
                            <tr><td colSpan="2"><b>{jacketInfo.deal_jacket_name}</b></td></tr>
                            <tr><td colSpan="2">&nbsp;</td></tr>
                            <tr><td colSpan="2">currently contains {jacketInfo.pageCount} pages</td></tr>
                            <tr><td colSpan="2">&nbsp;</td></tr>
                            <tr><td colSpan="2"><hr /></td></tr>
                            <tr><td colSpan="2">&nbsp;</td></tr>
                            {(imagesInDocument === 0) &&
                                <>
                                    <tr>
                                        <td colSpan="2">
                                            <span className="scanModalPromptMessage">
                                                Load pages in your scanner, then click the Scan button below to begin.
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2">
                                            <div style={{ margin: "0 auto", display: "block" }}>
                                                <span className="addonManagerChooseButton" onClick={() => acquireImage()}>Scan</span>
                                            </div>
                                        </td>
                                    </tr>
                                </>
                            }
                            {(imagesInDocument > 0) &&
                                <>
                                    <tr>
                                        <td colSpan="2">
                                            <span className="scanModalPromptMessage">
                                                {
                                                    showSpinner && <img src={spinnerImage} alt="spinner" />
                                                }
                                                {
                                                    !showSpinner && uploadSuccess &&
                                                    <>
                                                        Addon uploaded. Deal resubmitted to ingestion queue.
                                                    </>
                                                }
                                                {
                                                    !showSpinner && !uploadSuccess &&
                                                    <>
                                                        &nbsp;
                                                    </>
                                                }                                                
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2">
                                            <div className="tableRowTwoButtons">
                                                <span className="addonManagerButton" onClick={() => acquireImage()} >Scan more pages</span>
                                                <span className="addonManagerButton" onClick={uploadDoc}>Upload</span>
                                                <span className="addonManagerButton" onClick={() => clearImagesInDocument()}>Clear</span>
                                            </div>
                                        </td>
                                    </tr>
                                </>
                            }
                            <tr>
                                <td colSpan="2">
                                    <div className="modalScanViewerContainer">
                                        <div className="dwControlContainer" id={containerId}>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr><td colSpan="2">&nbsp;</td></tr>
                            <tr><td colSpan="2"><hr /></td></tr>
                            <tr><td colSpan="2">&nbsp;</td></tr>
                            <tr colSpan="2">
                                <td colSpan="2" align="center">
                                    <span id="cancel" className="classifyFormButton" name="cancelButton" onClick={toggleScanModal}>
                                        Cancel
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </form>
            </div>
        </div>

    );

}

function mapStateToProps(state) {
    const { authentication } = state;
    return {
        authentication,
    };
}

const actionCreators = {
    uploadJacket: dealjacketActions.uploadJacket,
};

const connectedScanModal = connect(
    mapStateToProps,
    actionCreators
)(ScanModal);
export { connectedScanModal as ScanModal };